import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { HolidayModel } from '@smarttask-common/src/lib/models/Resource/HolidayModel';

export enum HolidayActionTypes {
    ADD_HOLIDAY = '[Holiday] Create Holiday',
    ADD_HOLIDAYS = '[Holiday] Add Holidays',
    UPSERT_HOLIDAY = '[Holiday] Upsert Holiday',
    UPSERT_HOLIDAYS = '[Holiday] Upsert Holidays',
    UPDATE_HOLIDAY = '[Holiday] Update Holiday',
    UPDATE_HOLIDAYS = '[Holiday] Update Holidays',
    DELETE_HOLIDAY = '[Holiday] Delete Holiday',
    DELETE_HOLIDAYS = '[Holiday] Delete Holidays',
    DELETE_ALL_HOLIDAYS = '[Holiday] Delete All Holidays',
    DELETE_ALL = '[Holiday] Delete All',

    UPDATE_SELECTED_HOLIDAY = '[Holiday] Update SelectedRole',
}

export class UpdateSelectedHoliday implements Action {
    readonly type = HolidayActionTypes.UPDATE_SELECTED_HOLIDAY;
    constructor(public selected_holiday_id: string) {}
}

export class AddOne implements Action {
    readonly type = HolidayActionTypes.ADD_HOLIDAY;
    constructor(public holiday: HolidayModel) {}
}

export class AddMany implements Action {
    readonly type = HolidayActionTypes.ADD_HOLIDAYS;
    constructor(public holidays: Array<HolidayModel>) {}
}

export class UpsertOne implements Action {
    readonly type = HolidayActionTypes.UPSERT_HOLIDAY;

    constructor(public holiday: HolidayModel) {}
}

export class UpsertMany implements Action {
    readonly type = HolidayActionTypes.UPSERT_HOLIDAYS;
    constructor(public holidays: Array<HolidayModel>) {}
}

export class UpdateOne implements Action {
    readonly type = HolidayActionTypes.UPDATE_HOLIDAY;
    constructor(public holiday: Update<HolidayModel>) {}
}

export class UpdateMany implements Action {
    readonly type = HolidayActionTypes.UPDATE_HOLIDAYS;
    constructor(public holidays: Array<Update<HolidayModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = HolidayActionTypes.DELETE_HOLIDAY;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = HolidayActionTypes.DELETE_HOLIDAYS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = HolidayActionTypes.DELETE_ALL_HOLIDAYS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = HolidayActionTypes.DELETE_ALL;
    constructor() {}
}

export type HolidayActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedHoliday;
